import * as React from "react";
import classnames from "classnames";
import { FormContext } from "../../Form/Form/Form.js";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
/* empty css                         */
const MultipleAddressLine = ({
  addLineLabel,
  errorMessage,
  getInitialState,
  initialLineAmount = 1,
  label,
  lineThreeLabel,
  lineTwoLabel,
  maxLength,
  maxLengthLineTwo,
  maxLengthLineThree,
  disableAddLineThree,
  validations,
  streetValidations,
  required = true,
  shouldCombineAddress = false,
  streetComponent: Street = ConnectedFormControl
}) => {
  const [lineAmount, setLineAmount] = React.useState(initialLineAmount);
  const additionalStreetInfoValue = getInitialState && getInitialState("additionalStreetInfo");
  const additionalAddressInfoValue = getInitialState && getInitialState("additionalAddressInfo");
  if (additionalStreetInfoValue && additionalStreetInfoValue.value && lineAmount < 2) {
    setLineAmount(2);
  }
  if (additionalAddressInfoValue && additionalAddressInfoValue.value && lineAmount < 3) {
    setLineAmount(3);
  }
  const handleClick = () => {
    setLineAmount(lineAmount + 1);
  };
  const inputs = [
    /* @__PURE__ */ React.createElement(
      Street,
      {
        ...ConnectedFormControl.defaultProps,
        id: "streetName",
        key: "streetName",
        "data-t": "streetName",
        label,
        initialState: getInitialState && getInitialState("streetName"),
        errorMessage,
        validations: streetValidations || validations,
        required,
        maxLength,
        shouldCombineAddress
      }
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        key: "additionalStreetInfo",
        "data-t": "additionalStreetInfo",
        className: classnames("multiple-address-line__additional-line", {
          "multiple-address-line__additional-line--hidden": lineAmount < 2
        })
      },
      /* @__PURE__ */ React.createElement(
        ConnectedFormControl,
        {
          ...ConnectedFormControl.defaultProps,
          id: "additionalStreetInfo",
          key: "additionalStreetInfo",
          "data-t": "additionalStreetInfoFormControl",
          required: false,
          initialState: getInitialState && getInitialState("additionalStreetInfo"),
          errorMessage,
          validations,
          maxLength: maxLengthLineTwo ?? maxLength,
          label: lineTwoLabel
        }
      )
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        key: "additionalAddressInfo",
        "data-t": "additionalAddressInfo",
        className: classnames("multiple-address-line__additional-line", {
          "multiple-address-line__additional-line--hidden": lineAmount < 3
        })
      },
      /* @__PURE__ */ React.createElement(
        ConnectedFormControl,
        {
          ...ConnectedFormControl.defaultProps,
          key: "additionalAddressInfo",
          id: "additionalAddressInfo",
          "data-t": "additionalAddressInfoFormControl",
          required: false,
          initialState: getInitialState && getInitialState("additionalAddressInfo"),
          errorMessage,
          validations,
          maxLength: maxLengthLineThree ?? maxLength,
          label: lineThreeLabel
        }
      )
    )
  ];
  return /* @__PURE__ */ React.createElement("div", { className: "multiple-address-line" }, inputs, lineAmount < inputs.length && !disableAddLineThree && /* @__PURE__ */ React.createElement("button", { type: "button", className: "multiple-address-line__add-lines", onClick: handleClick }, addLineLabel));
};
const ConnectedMultipleAddressLine = ({
  ...props
}) => /* @__PURE__ */ React.createElement(FormContext.Consumer, null, (context = {}) => /* @__PURE__ */ React.createElement(MultipleAddressLine, { ...props, getInitialState: context.getInitialState }));
ConnectedMultipleAddressLine.defaultProps = {
  ...MultipleAddressLine.defaultProps
};
export {
  MultipleAddressLine,
  ConnectedMultipleAddressLine as default
};
//# sourceMappingURL=MultipleAddressLine.js.map
